const STAGE_MAPPING: Record<string, string> = {
    "bookmarks.opstechit.amazon.dev": "PROD",
    "beta.bookmarks.opstechit.amazon.dev": "BETA",
};

const DEFAULT_STAGE: string = "ALPHA";

const currentHostName: string = window.location.hostname;

const stage: string = STAGE_MAPPING[currentHostName] || DEFAULT_STAGE;

export const currentStage: string = stage;

export default stage;
